export default "../static/img/9d7d1f2032c1445fe584c895f359bcea.jpg";